import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import ViewerDocument from '../../../../../shared/components/ViewerDocument/ViewerDocument'

import useQuotationClient from '../../../../../clients/QuotationClient/useQuotationClient'

const DraftViewer = () => {
  const quotationClient = useQuotationClient()

  const { search } = useLocation()
  const { quotationIdentifier } = useParams()

  const [draftData, setDraftData] = useState('')

  useEffect(() => {
    const query = new URLSearchParams(search)

    quotationClient().getDraftMulticalculo({
      identifier: quotationIdentifier,
      documentId: query.get('documentId'),
      proposalUniqueId: query.get('proposalUniqueId'),
      insuranceUniqueId: query.get('insuranceUniqueId'),
    }).then((response) => {
      setDraftData(response.data)
    })
  }, [search, quotationIdentifier, quotationClient])

  return (
    <ViewerDocument documentBase64={draftData} />
  )
}

export default DraftViewer
